/** @constant {object} */
export const EVENTS = {
  LANG_SWITCHED: 'core/i18n/onLangSwitch',
  ISSUE_MONITORED: 'core/monitoring/onIssueThrowed',
}

/**
 * @constant {string}
 * @default "core"
 */
export const STORE_PREFIX = 'core'

/** @constant {object} */
export const ERRORS = {
  UNKNOWN_LOCALE: 'provided locale is not handled',
}

/**
 * @constant {undefined}
 * @readonly
 * @desc
 *    Idiomatic representation,
 *    Useful for stating that some code branch is impossible
*/
export const ABSURD = undefined

/** @constant {string} */
export const BROADCAST_CHANNEL_ID = 'cloud-ghs'

/**
 * @constant {BroadcastChannel}
 * @readonly
 */
export const broadcastChannel = new BroadcastChannel(BROADCAST_CHANNEL_ID)

/** @constant */
export const APP_ID = '__nuxt'
